import { useRef } from 'react';

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>(undefined);
  // eslint-disable-next-line react-hooks/refs
  const previous = ref.current;
  // eslint-disable-next-line react-hooks/refs
  ref.current = value;
  return previous;
};
